import moment from 'moment'
let mobile = require('is-mobile')

const filterDefaultValues = {
  dateStart: null,
  dateEnd: null,
  maxPeople_from: 2,
  type: 'all',
  region: 'all',
  bedrooms_from: null,
  bedrooms_to: null,
  csrId: null,
  page: 1,
  visible: "true",
  priceRange: 'all',
  sortBy: 'sortOrder',
  rowsPerPage: 7,
  parking: 'all',
  pool: 'all',
  terrace: 'all',
  aircon: 'all',
  pets: 'all',
  bedroomsCount: 'all',
  bathroomCount: 'all',
  favorites: 0
}

const bookingDataDefaults = {
  checkInTime: '16:00',
  checkOutTime: '12:00',
  payMonthly: false,
  customerName: null,
  customerPhone: null,
  customerEmail: null,
  confirmed: false,
  notes: '',
  flightDepartureInfo: '',
  flightArrivalInfo: '',
  infants: 0,
  adults: 2,
  kids: 0
}

export default {
  scrolledTop: 0,
  lang: 'en',
  isHydrated: false,
  showArticleOnly: false,
  openTs: 0,
  favorites: [],
  languages: ['en', 'es', 'fi', 'et', 'ru'],
  priceObject: {},
  showBookNowForm: false,
  loadingObjectInfo: false,
  metaSiteName: 'Costasolrent.com',
  metaUrl: 'https://www.costasolrent.com',
  metaTitle: null,
  metaDescription: null,
  metaImage: null,
  defaultMetaUrl: 'https://www.costasolrent.com',
  defaultMetaTitle: 'Costasolrent.com',
  defaultMetaDescription: 'Costasolrent.com Vacation Homes and Villas',
  defaultMetaImage: 'https://www.costasolrent.com/img/costasolrent_logo.png',
  metaType: 'article',
  detailedSearch: false,
  bookingExtras: [],
  bookingExtrasSelected: {},
  objectRegions: [],
  showSearchPickerFor: null,
  showBookingPickerFor: null,

  featuresList: {},
  featureGroups: [],
  filtersHash: null,
  objectRoomTypesById: {},
  translationsByLang: {},
  contactOptions: [{
    link: 'mailto:info@costasolrent.com',
    title_translation: 'e-mail',
    colon: true,
    title: 'info@costasolrent.com',
    icon: 'fa-envelope'
  }, {
    link: 'https://wa.me/34633493690',
    title: '',
    title_translation: 'send_whatsapp',
    icon: 'fab fa-whatsapp'
  }, {
    link: 'tel:+34633786060',
    title_translation: 'call',
    title: ' +34 633 786 060',
    icon: 'fa-phone'
  }, {
    link: 'sms:+34633493690',
    title_translation: 'send_sms',
    title: '',
    icon: 'fa-sms'
  }],
  bookingStatuses: {
    '5bebc64a46853c27bcfe3dc8': 'confirmed',
    '5bebc64446853c27bcfe3dc7': 'new',
    '5e5a0fba9c2acb1241c0798d': 'owner',
    '5bebc65846853c27bcfe3dca': 'archived'
  },
  bookingData: JSON.parse(JSON.stringify(bookingDataDefaults)),
  bookingDataDefaults: JSON.parse(JSON.stringify(bookingDataDefaults)),
  bookNowObject: {},
  bookNowAvailable: false,
  hotImages: [],
  isHomepage: true,
  progressSearching: false,
  progressOpening: false,
  progressHot: true,
  templateVarsByLang: {},
  pageId: null,
  menuResponse: [],
  pagesById: {},
  pagesBySeoName: {},
  bannersByLang: {},
  galleriesByArticleId: {},
  searchResult: [],
  searchTotal: 0,
  selectedObject: {
    bookedDays: {}
  },

  // Image
  showingFullImage: false,
  previewImage1: {},
  previewImage2: {},
  fullImage1: {},
  fullImage2: {},
  previewSideImage2: {},
  previewSideImage3: {},
  imageUrl1: null,
  imageUrl2: null,
  image1Transparent: false,
  image2Transparent: true,
  selectedImageIndex: 0,
  whichImageShowing: 1,
  showingImageNavigation: mobile() ? true : false,
  imagePreviewThumbnailLeftOffset: 0,
  imageAutoSwitchTimer: null,
  s3url: 'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/',
  preloadImg1: null,
  preloadImg2: null,
  mobile: mobile(),
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  contentAreaWidth: 837,

  calendarYear: moment().format('Y'),
  calendarMonth: moment().format('MM'),
  checkInCalendarYear: moment().format('Y'),
  checkInCalendarMonth: moment().format('MM'),
  showLeftMenu: false,
  showRightMenu: false,
  showEmailModal: false,
  rowsPerHomePage: 12,
  searchFilters: JSON.parse(JSON.stringify(filterDefaultValues)),
  filterDefaultValues: JSON.parse(JSON.stringify(filterDefaultValues)),
  weather: {},
  weatherNightIcons: {
    'sunny': 'moon',
    'partlycloudy': 'moon'
  },
  weatherCodes: {
    395: 'snow',
    392: 'tstorms',
    389: 'rain',
    386: 'rain',
    377: 'rain',
    374: 'rain',
    371: 'snow',
    368: 'snow',
    365: 'rain',
    362: 'rain',
    359: 'rain',
    356: 'rain',
    353: 'rain',
    350: 'snow',
    338: 'snow',
    335: 'snow',
    332: 'snow',
    329: 'snow',
    326: 'snow',
    323: 'snow',
    320: 'rain',
    317: 'rain',
    314: 'rain',
    311: 'rain',
    308: 'rain',
    305: 'rain',
    302: 'rain',
    299: 'rain',
    296: 'rain',
    293: 'rain',
    284: 'snow',
    281: 'snow',
    266: 'snow',
    263: 'snow',
    260: 'fog',
    248: 'fog',
    230: 'rain',
    227: 'snow',
    200: 'tstorms',
    185: 'rain',
    182: 'cloudy',
    179: 'snow',
    176: 'rain',
    143: 'fog',
    122: 'cloudy',
    119: 'cloudy',
    116: 'cloudy',
    113: 'sunny'
    /*
    1000:	'sunny',
    11611:	'partlycloudy',
    1006:	'cloudy',
    1009:	'cloudy',
    1030:	'rain',
    1063:	'rain',
    1066:	'snow',
    1069:	'sleet',
    1072:	'rain',
    1087:	'tstorms',
    1114:	'snow',
    1117:	'rain',
    1135:	'fog',
    1147:	'fog',
    1150:	'rain',
    1153:	'rain',
    1168:	'rain',
    1171:	'rain',
    1180:	'rain',
    1183:	'rain',
    1186:	'rain',
    1189:	'rain',
    1192:	'rain',
    1195:	'rain',
    1198:	'rain',
    1201:	'rain',
    1204:	'sleet',
    1207:	'sleet',
    1210:	'snow',
    1213:	'snow',
    1216:	'snow',
    1219:	'snow',
    1222:	'snow',
    1225:	'snow',
    1237:	'snow',
    1240:	'rain',
    1243:	'rain',
    1246:	'rain',
    1249:	'sleet',
    1252:	'sleet',
    1255:	'snow',
    1258:	'snow',
    1261:	'snow',
    1264:	'snow',
    1273:	'tstorms',
    1276:	'tstorms',
    1279:	'tstorms',
    1282:	'tstorms'*/
  }
}
